import { firestore } from '@psl/functions/firebase/firebaseAccess';

export const userPrivateProfileDoc = (id: string) =>
  firestore().collection('privateProfiles').doc(id);
